import React from 'react'
import { Button, Checkbox, FormControlLabel, Radio, RadioGroup, Step, StepButton, StepLabel, Stepper, TextField, Typography } from '@mui/material';
import Link from 'next/link';
import parse from 'html-react-parser';
import useRecertificationSlides from './hooks/useRecertificationSlides';
import { xor } from 'lodash';
import { RequestNextApi } from '../../../../api/Request';
import { getCookie } from '../../../../utils/cookieHandle';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import { useRouter } from 'next/router';
import { combineArrayElements } from '../../../../utils/array';
import { ProgressContext } from '../../../Context/progressContext';
import useMediaQuery from '@mui/material/useMediaQuery';

const FaithBasedInvestingInner = () => {
    const fbiClient = useRecertificationSlides((state) => state.fbiFields.fbiClient)
    const fbiExperience = useRecertificationSlides((state) => state.fbiFields.fbiExperience)
    const fbiSearch = useRecertificationSlides((state) => state.fbiFields.fbiSearch)
    const fbiTraining = useRecertificationSlides((state) => state.fbiFields.fbiTraining)

    const setFbiField = useRecertificationSlides((state) => state.setFbiField)
    const setFbiFields = useRecertificationSlides((state) => state.setFbiFields)
    const index = useRecertificationSlides((state) => state.activeSlideIndex)
    const slide = useRecertificationSlides((state) => state.slides?.[index])
    const modifySlide = useRecertificationSlides((state) => state.modifySlide)

    const totalSlides = useRecertificationSlides((state) => state.totalSlides)
    const setActiveSlideIndex = useRecertificationSlides((state) => state.setActiveSlideIndex)
    const allRequiredSlidesConfirmed = useRecertificationSlides((state) => state.allRequiredSlidesConfirmed)

    const onChangeFbiTraining = (e) => {
        const numberOfTrainings = fbiTraining?.length || 0
        setFbiField('fbiTraining', xor(fbiTraining, [e.target.name]))
        if (e.target.checked && fbiClient && fbiExperience) {
            modifySlide(index, { isCompleted: true, isAcknowledged: true }, true)
        }
        if (!e.target.checked && ((numberOfTrainings - 1) < 1)) {
            modifySlide(index, { isCompleted: false, isAcknowledged: false }, true)
        }
    }

    const onChangeFbiSearch = (e) => {
        if (e.target.value == 0) {
            setFbiFields({
                fbiSearch: e.target.value,
                fbiTraining: [],
                fbiExperience: "",
                fbiClient: "",
            })
            modifySlide(index, {
                requiresConfirmation: false,
                isAcknowledged: false,
                isCompleted: false,
            }, true)

        } else {
            setFbiFields({
                fbiSearch: e.target.value,
                fbiTraining: [],
                fbiExperience: "",
                fbiClient: "",

            })
            modifySlide(index, {
                requiresConfirmation: true,
                isAcknowledged: false,
                isCompleted: false,
            }, true)
        }
    }

    const onChangeFbiExperience = (e) => {
        setFbiField('fbiExperience', e.target.value)
        if (e.target.value && fbiClient && fbiTraining.length) {
            modifySlide(index, { isCompleted: true, isAcknowledged: true }, true)
        }
        if (!e.target.value) {
            modifySlide(index, { isCompleted: false, isAcknowledged: false }, true)
        }
    }

    const onChangeFbiClient = (e) => {
        setFbiField('fbiClient', e.target.value)
        if (e.target.value && fbiExperience && fbiTraining.length) {
            modifySlide(index, { isCompleted: true, isAcknowledged: true }, true)
        }
        if (!e.target.value) {
            modifySlide(index, { isCompleted: false, isAcknowledged: false }, true)
        }
    }



    const handlePrevious = () => {
        if (index) {
            setActiveSlideIndex(index - 1)
        }
    }

    const handleNext = () => {
        if (fbiSearch == 1) {
            setActiveSlideIndex(index + 1)
        } else {
            modifySlide(index, { isCompleted: true }, true)
            setActiveSlideIndex(index + 1)
        }
    }

    const handleFinish = () => {
        setActiveSlideIndex(index + 1)
    }

    if (!slide) {
        return <></>
    }

    return (
        <>
            <Typography component='div' className='text-2xl text-secondary-500'>
                {index + 1}. {slide.sectionTitle}
            </Typography>
            <div className="my-5">
                <div>
                    Clients searching for a Certified Kingdom Advisor<sup>®</sup> can
                    indicate if they need investing advice and whether they are looking for
                    traditional
                    investing or faith-based investing. If you qualify and want to be
                    searchable in the CKA<sup>®</sup> directory as a provider of <strong>faith-based
                        investing</strong>, please complete the requirements below.
                </div>
                <div className="mt-4">
                    <strong>NOTE</strong>: This Faith-Based Investing Attestation is
                    designed only for CKA<sup>®</sup> designees who meet the Investment
                    Professional Discipline requirements
                    (<Link href="/get-certified" target="_blank">shown here</Link>). If you
                    do not qualify for the Investment Professional
                    Discipline, you should skip this Faith-Based Investing Attestation, as
                    your profile will not be shown to those seeking investment advice.
                </div>
                <div className="mt-4">
                    If these do <strong>not</strong> apply to your situation or if you do
                    not want to answer these questions, please skip over this section and
                    save your profile without completing this attestation. This section is
                    completely
                    optional.
                </div>
                <div className="mt-4">
                    <strong>THREE REQUIREMENTS</strong>: CKA<sup>®</sup>s can qualify to
                    appear in the search results of those seeking advice for faith-based
                    investing by positively affirming all three questions below.
                    <ol>
                        <li>Have you completed an approved faith-based investing course?
                        </li>
                        <li>Do you personally use faith-based investing?</li>
                        <li>Do you help clients with faith-based investing?</li>
                    </ol>
                    If you can answer yes to all three of these questions, please
                    acknowledge &apos;YES&apos; and complete
                    the attestation below.
                </div>
                <div className="mt-4">
                    Still have
                    questions? <Link href="https://kawebresources.s3.amazonaws.com/sitedownloads/Faith-Based%20Investing%20Attestation_Advisor%20FAQ_2025.pdf" target="_blank">Advisor
                        FAQ: Faith-Based Investing Attestation</Link>.
                </div>
                <RadioGroup
                    row
                    value={fbiSearch}
                    onChange={onChangeFbiSearch}
                    className="flex"
                >
                    <FormControlLabel value="1" control={<Radio color="secondary" />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio color="secondary" />} label="No" />
                </RadioGroup>
            </div>
            {fbiSearch == 1 ? (
                <div>
                    <div className="font-bold mt-5">1. Advisor Training</div>
                    <div>
                        I hereby attest that I have completed at least one of the approved training courses on faith-based
                        investing listed below.
                    </div>
                    <div className="my-4 space-y-4 flex flex-col">
                        <FormControlLabel
                            control={
                                <Checkbox color="secondary" checked={fbiTraining?.includes('KA')} name="KA" onChange={onChangeFbiTraining} />}
                            label="Kingdom Advisors: Faith-Based Investing course (2 hours)"
                        />
                        <div>
                            Click{' '}
                            <Link href="/members/resources/courses" legacyBehavior>
                                <a target="_blank" rel="noopener noreferrer">
                                    HERE
                                </a>
                            </Link>{' '}
                            for more information on KA courses
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox color="secondary" checked={fbiTraining?.includes('Eventide')} name="Eventide" onChange={onChangeFbiTraining} />}
                            label="Eventide Center for Faith & Investing: Financial Advisor course (9 hours)"
                        />
                        <div>
                            <Link legacyBehavior href="https://www.faithandinvesting.com/courses/financial-advisor-course/" target="_blank">
                                Visit Eventide Center for Faith & Investing
                            </Link>
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox color="secondary" checked={fbiTraining?.includes('FDI')} name="FDI" onChange={onChangeFbiTraining} />}
                            label="Faith Driven Investor: Financial Advisor Foundation Groups (6 hours)"
                        />
                        <div>
                            <Link legacyBehavior href="https://groups.faithdrivenentrepreneur.org/app/home/filter/user-format?userRole=INVESTOR&investorTypes=FINANCIAL_ADVISOR" target="_blank">
                                Visit Faith Driven Investor
                            </Link>
                        </div>
                    </div>
                    <div className="font-bold mt-5">2. Investing Experience</div>
                    <div>
                        <em>I hereby attest that I have researched the investing solutions at my firm, have implemented faith-based investing with at least some of my own personal assets, and currently offer this investing strategy to my clients.</em>
                    </div>
                    <TextField
                        inputProps={{ maxLength: 3 }}
                        color='third'
                        fullWidth
                        size='small'
                        defaultValue={fbiExperience}
                        id='investing-experience'
                        placeholder='Acknowledge by typing your initials'
                        onChange={onChangeFbiExperience}
                    />
                    <div className='font-bold mt-5'>3. Client Commitment</div>
                    <div>
                        I will educate my clients about faith-based investing while honoring their convictions and requests in this regard. Knowing that Kingdom Advisors sees investing as a matter of personal discernment, I will seek to communicate about this topic in ways that honor the ability of Christians to differ about the best way to invest.
                    </div>
                    <div>I hereby attest that I have read, understand, and agree with the above client commitment:</div>
                    <TextField
                        inputProps={{ maxLength: 3 }}
                        color='third'
                        fullWidth
                        size='small'
                        defaultValue={fbiClient}
                        id='client-commitment'
                        placeholder='Acknowledge by typing your initials'
                        onChange={onChangeFbiClient}
                    />
                </div>
            ) : (
                ''
            )}
            <div className='flex justify-center my-8'>
                <div className={`w-[200px] ${index ? "justify-between" : "justify-center"} flex`}>
                    {!!index &&
                        <Button
                            type='submit'
                            variant='outlined'
                            className='w-[80px]'
                            onClick={handlePrevious}
                        >
                            Previous
                        </Button>}
                    {index < (totalSlides - 1) &&
                        <Button
                            type='submit'
                            variant='outlined'
                            className='w-[80px]'
                            onClick={handleNext}
                        >
                            Next
                        </Button>}
                    {allRequiredSlidesConfirmed && index >= (totalSlides - 1) && (
                        <Button
                            type='submit'
                            variant='outlined'
                            className='w-[80px]'
                            onClick={handleFinish}
                        >
                            Finish
                        </Button>
                    )}
                </div>
            </div>
        </>
    )
}
const FaithBasedInvesting = React.memo(FaithBasedInvestingInner)

const SubmitSlideInner = ({ userId }) => {
    const { update: updateProgress } = React.useContext(ProgressContext);

    const router = useRouter();

    const fbiClient = useRecertificationSlides((state) => state.fbiFields.fbiClient)
    const fbiExperience = useRecertificationSlides((state) => state.fbiFields.fbiExperience)
    const fbiSearch = useRecertificationSlides((state) => state.fbiFields.fbiSearch)
    const fbiTraining = useRecertificationSlides((state) => state.fbiFields.fbiTraining)

    const saveCka = async (params) => {
        try {
            updateProgress({ isLoading: true });
            const result = await RequestNextApi.post('/cka/user-save-cka', {
                fields: {
                    user: params,
                },
                jwtToken: getCookie('jwt-token'),
                ...(userId ? { userId } : {}),
            });
            if (result.data.success) {
                await submitRecertificationRequest();
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (error) {
            ShowNotification.error('Save information failed');
        } finally {
            updateProgress({ isLoading: false });
        }
    };
    const submitRecertificationRequest = async () => {
        try {
            const result = await RequestNextApi.post('/recertification/submit-recertification', {
                jwtToken: getCookie('jwt-token'),
                ...(userId ? { userId } : {}),
            });
            if (result.data.success) {
                ShowNotification.success(result.data.message);
                if (userId) {
                    router.push(`/staff/user/${userId}/certification`);
                } else {
                    router.push('/members/account/certification');
                }
            } else {
                ShowNotification.info(result.data.message);
            }
        } catch (error) {
            ShowNotification.error('Request failed');
        }
    };

    const onSubmit = () => {
        saveCka({
            fbiSearch: fbiSearch,
            fbiTraining: combineArrayElements(fbiTraining, '|'),
            fbiExperience: fbiExperience,
            fbiClient: fbiClient,
        });
    }
    return (
        <div className='bg-white border mt-3 px-5 py-6 rounded-xl border-solid border-primary-100 shadow'>
            <Typography variant='h4' color='secondary'>
                Requirements Met
            </Typography>
            <Typography variant='body1' className='my-6'>
                You have acknowledged all that we&apos;ve asked and are now ready to submit your certification
            </Typography>
            <Button variant='contained' color='secondary' onClick={onSubmit}>
                Submit for Recertification
            </Button>
        </div>
    )
}
const SubmitSlide = React.memo(SubmitSlideInner)

const SingleSlideInner = () => {
    const index = useRecertificationSlides((state) => state.activeSlideIndex)
    const slide = useRecertificationSlides((state) => state.slides?.[index])
    const setActiveSlideIndex = useRecertificationSlides((state) => state.setActiveSlideIndex)

    const modifySlide = useRecertificationSlides((state) => state.modifySlide)

    const totalSlides = useRecertificationSlides((state) => state.totalSlides)

    const isSubmissionStep = slide?.submissionStep && !slide?.requiresConfirmation
    const allRequiredSlidesConfirmed = useRecertificationSlides((state) => state.allRequiredSlidesConfirmed)

    const onAcknowledge = (e) => {
        e.preventDefault()
        const formData = new FormData(e.target);
        const formObject = Object.fromEntries(formData.entries());
        if (formObject.initials.length) {
            modifySlide(index, { isAcknowledged: true, isCompleted: true }, true)
        }
    }

    const onChangeInitials = (e) => {
        const toSave = { initials: e.target.value }

        if (slide?.isCompleted || slide?.isAcknowledged) {
            toSave.isCompleted = false
            toSave.isAcknowledged = false
        }

        modifySlide(index, toSave, !!(slide?.isCompleted || slide?.isAcknowledged))
    }

    const handlePrevious = () => {
        if (index) {
            setActiveSlideIndex(index - 1)
        }
    }

    const handleNext = () => {
        if (!index) {
            modifySlide(index, { isCompleted: true }, true)
            setActiveSlideIndex(index + 1)
        } else {
            setActiveSlideIndex(index + 1)
        }
    }

    const handleFinish = () => {
        setActiveSlideIndex(index + 1)
    }


    if (!slide) {
        return <></>
    }


    if (isSubmissionStep) {
        return <SubmitSlide />
    }

    if (slide.sectionTitle == 'Kingdom Advisors Faith-Based Investing Attestation (Available Option for Investment Professionals)') {
        return <FaithBasedInvesting />
    }

    if (slide.sectionTitle == 'Faith-Based Investing (optional)') {
        return <FaithBasedInvesting />
    }


    return (
        <div>
            <Typography component='div' className='text-2xl text-secondary-500'>
                {!isSubmissionStep ? `${index + 1}. ` : ""}{slide.sectionTitle}
            </Typography>
            <div>
                <Typography component='div'>{parse(slide.sectionContent ?? '')}</Typography>
                {!!slide.requiresConfirmation &&
                    <form
                        method='POST'
                        className='flex'
                        onSubmit={onAcknowledge}
                    >
                        <TextField
                            inputProps={{ maxLength: 3 }}
                            size='small'
                            name={"initials"}
                            placeholder='Type your initials...'
                            className='mr-2'
                            onChange={onChangeInitials}
                            value={slide?.initials || ""}
                        />
                        {!slide?.isAcknowledged && <Button type='submit' variant='outlined'>
                            Acknowledge
                        </Button>}
                    </form>
                }
                <div className='flex justify-center my-8'>
                    <div className={`w-[200px] ${index ? "justify-between" : "justify-center"} flex`}>
                        {!!index && <Button type='submit' variant='outlined' className='w-[80px]'
                            onClick={handlePrevious}
                        >
                            Previous
                        </Button>}
                        {index < (totalSlides - 1) && <Button type='submit' variant='outlined' className='w-[80px]' onClick={handleNext}>
                            Next
                        </Button>}
                        {
                            allRequiredSlidesConfirmed && index >= (totalSlides - 1) && (
                                <Button type='submit' variant='outlined' className='w-[80px]' onClick={handleFinish}>
                                    Finish
                                </Button>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
const SingleSlide = React.memo(SingleSlideInner)

function AcknowledgementSlides() {

    const slides = useRecertificationSlides((state) => state.slides)
    const totalSlides = useRecertificationSlides((state) => state.totalSlides)
    const activeSlide = useRecertificationSlides((state) => state.activeSlideIndex)
    const setActiveStep = useRecertificationSlides((state) => state.setActiveSlideIndex)
    const allRequiredSlidesConfirmed = useRecertificationSlides((state) => state.allRequiredSlidesConfirmed)

    const isSmallScreen = useMediaQuery('(max-width:900px)');

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleFinish = () => {
        if (allRequiredSlidesConfirmed) {
            setActiveStep(totalSlides)
        }
    }

    if (!slides.length) {
        return <></>
    }

    return (
        <div className={`${isSmallScreen ? "flex" : ""}`}>
            <div className={isSmallScreen ? '' : 'mt-8'}>
                <Stepper nonLinear activeStep={activeSlide}
                    orientation={isSmallScreen ? 'vertical' : 'horizontal'}
                >
                    {slides.map((_, index) => {
                        return (
                            <Step key={index} completed={!!slides?.[index]?.isCompleted}>
                                <StepLabel StepIconComponent={() => {
                                    if (!_.requiresConfirmation && _.submissionStep) {
                                        return <Button
                                            disabled={!allRequiredSlidesConfirmed}
                                            className={allRequiredSlidesConfirmed ? 'cursor-pointer' : "cursor-default"}
                                            onClick={handleFinish}>
                                            Finish
                                        </Button>
                                    } else {
                                        return (
                                            <StepButton onClick={handleStep(index)} completed={!!slides?.[index]?.isCompleted} />
                                        )
                                    }
                                }} />
                            </Step>
                        )
                    })}
                </Stepper>
            </div>
            <div className='mt-6'>
                <SingleSlide />
            </div>
        </div>
    )
}

export default AcknowledgementSlides
